import store from '../store';
import {
  NEW_MESSAGE,
  SET_USER_TYPING_STATUS,
  SET_MESSAGE_STATUS,
  SOCKET_ERROR,
} from '../store/types';

export default {
  socketConnect: () => {
    console.log('Socket connected');
  },
  socketDisconnect: () => {
    console.log('Socket disconnected');
  },
  socketReconnect: () => {
    console.log('Socket reconnect');
  },
  socketError: (err) => {
    console.log('Socket error', err);
    store.commit(SOCKET_ERROR, err);
  },
  messageStatus: (message) => {
    store.commit(SET_MESSAGE_STATUS, message);
  },
  receiveMessage: (message) => {
    store.commit(NEW_MESSAGE, message);
  },
  setUserTyping: (data) => {
    store.commit(SET_USER_TYPING_STATUS, data);
  },
  setUserEndTyping: () => {
    store.commit(SET_USER_TYPING_STATUS, null);
  },

};
